export default {
  新增模板: "新增模板",
  评估物料: "评估物料",
  评估阶段: "评估阶段",
  评估维度: "评估维度",
  评估项: "评估项",
  评估物料类别: "评估物料类别",
  评估阶段_标题: "评估阶段",
  取消: "取消",
  保存: "保存",
  新增评估阶段: "+ 新增评估阶段",
  请输入评估物料类别: "请输入评估物料类别",
  请完善表单信息: "请完善表单信息",
  保存成功: "保存成功",
  保存失败: "保存失败",
  加载中: "加载中...",
  序号: "序号",
  评估部门: "评估部门",
  评估等级: "评估等级",
  等级描述: "等级描述",
  操作: "操作",
  暂无评估项: "暂无评估项，请点击下方按钮添加",
  添加: "+ 添加",
  请输入: "请输入",
  请选择: "请选择",
  请输入评估项: "请输入评估项",
  请选择评估部门: "请选择评估部门",
  确认删除: "确认删除",
  确定删除模板: "确定要删除该评估模板吗？",
  确定: "确定",
  删除成功: "删除成功",
  删除失败: "删除失败",
  删除维度: "删除维度",
  请输入评估维度: "请输入评估维度",
  评估阶段_占位符: "评估阶段",
  删除阶段: "删除阶段",
  新增维度: "+ 新增维度",
  请输入评估阶段: "请输入评估阶段",
  评估标准: "评估标准",
  等级: "等级",
  描述: "描述",
  评估部门_表头: "评估部门",
};
